const TYPE = {
  $id: "orders.json",
  type: "object",
  properties: {
    bodDate: {
      type: 'timestamp'
    },
    costs: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          date: {
            type: 'timestamp'
          }
        }
      }
    },
    deliveryEndTime: {
      type: 'timestamp'
    },
    deliveryStartTime: {
      type: 'timestamp'
    },
    lastModifiedTime: {
      type: 'timestamp'
    },
    documentList: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          uploadDate: {
            type: 'timestamp'
          },
        }
      }
    },
    exportWarehouseDate: {
      type: 'timestamp'
    },
    mfgExpectedDate: {
      type: 'timestamp'
    },
    payments: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          paymentDate: {
            type: 'timestamp'
          },
        }
      }
    },
    transportClearanceDate: {
      type: 'timestamp'
    },
    transportDeclarationFormDate: {
      type: 'timestamp'
    },
    transportETA: {
      type: 'timestamp'
    },
    transportETD: {
      type: 'timestamp'
    },
    transportOriginalDocument: {
      type: 'timestamp'
    },
    transportScanDate: {
      type: 'timestamp'
    },
  },
};
module.exports = {
  TYPE
}